import { render, staticRenderFns } from "./CheckoutConfirmation.vue?vue&type=template&id=afbe9416&"
import script from "./CheckoutConfirmation.vue?vue&type=script&lang=js&"
export * from "./CheckoutConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutConfirmation.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports